import { ChipProps } from 'ui';

import { RiskScores } from '../../types';

export const getChipColor = (riskScore: RiskScores | null): ChipProps['color'] => {
  switch (riskScore) {
    case 'LR':
      return 'success';
    case 'LI':
      return 'warning';
    case 'HR':
      return 'error';
    case 'PD':
      return 'secondary';
    case 'ND':
      return 'primary';
    default:
      return 'default';
  }
};
